import { useEffect, useState, useCallback } from "react";
import Title from "../components/Title";
import Button from "../components/Button";
import Card from "../components/Card";
import Input from "../components/Input";
import Navbar from "../components/Navbar";
import Grid from "../components/Grid";
import Calendar from "react-calendar";
import { apiUrl } from "../utils/api";
import { calculateShiftSalary } from "../utils/salary";
import {
  createLocalDateFromInputValue,
  formatInputDateToJapanese,
  getDaysInMonthFromInputValue,
  getJstCurrentMonthInputValue,
  getJstTodayInputValue,
} from "../utils/jst";

const timeOptions = [
  "00:00","00:30","01:00","01:30","02:00","02:30",
  "03:00","03:30","04:00","04:30","05:00","05:30",
  "06:00","06:30","07:00","07:30","08:00","08:30",
  "09:00","09:30","10:00","10:30","11:00","11:30",
  "12:00","12:30","13:00","13:30","14:00","14:30",
  "15:00","15:30","16:00","16:30","17:00","17:30",
  "18:00","18:30","19:00","19:30","20:00","20:30",
  "21:00","21:30","22:00","22:30","23:00","23:30"
];

function isSameLocalDate(inputValue, date) {
  const inputDate = createLocalDateFromInputValue(inputValue);
  return (
    inputDate.getFullYear() === date.getFullYear() &&
    inputDate.getMonth() === date.getMonth() &&
    inputDate.getDate() === date.getDate()
  );
}

function createEmptyAttendanceForm() {
  return {
    userId: "",
    date: getJstTodayInputValue(),
    clockIn: "09:00",
    clockOut: "18:00",
    breakStart: "",
    breakEnd: "",
  };
}

function formatHoursMinutes(hours) {
  const totalMinutes = Math.round(Number(hours || 0) * 60);
  const displayHours = Math.floor(totalMinutes / 60);
  const displayMinutes = totalMinutes % 60;
  return `${displayHours}h${displayMinutes}m`;
}

function Admin({ setUser,setPage }) {

  const [selectedDate, setSelectedDate] =useState(createLocalDateFromInputValue(getJstTodayInputValue()));
  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [editShiftId, setEditShiftId] =useState(null);
  const [tab, setTab] = useState("users");
  const token =localStorage.getItem("token");
	const [salaryMonth, setSalaryMonth] = useState(getJstCurrentMonthInputValue);
	const [search,setSearch]=useState("");
	const thStyle = {
    borderBottom: "1px solid #e5e7eb",
    padding: "12px 10px",
    background: "#f9fafb",
    color: "#374151",
    fontSize: "12px",
    fontWeight: 700,
    textAlign: "center",
    whiteSpace: "nowrap",
	};
	const tdStyle = {
    borderBottom: "1px solid #eef2f7",
    padding: "12px 10px",
    textAlign: "center",
    fontSize: "13px",
	};
	const moneyCellStyle = {
    ...tdStyle,
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
	};
	const tableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    marginTop: "14px",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
  };
  const shiftTableStyle = {
    width: "max-content",
    minWidth: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    marginTop: 0,
    fontSize: "12px",
  };
  const shiftTableWrapStyle = {
    overflow: "auto",
    marginTop: "20px",
    maxHeight: "min(60vh, 420px)",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    background: "#fff",
  };
  const stickyNameHeaderStyle = {
    ...thStyle,
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 5,
    minWidth: "120px",
    background: "#f9fafb",
    boxShadow: "1px 0 0 #e5e7eb",
    backgroundClip: "padding-box",
  };
  const stickyDayHeaderStyle = {
    ...thStyle,
    position: "sticky",
    top: 0,
    zIndex: 4,
    background: "#f9fafb",
    backgroundClip: "padding-box",
  };
  const stickyNameCellStyle = {
    ...tdStyle,
    position: "sticky",
    left: 0,
    zIndex: 2,
    minWidth: "120px",
    background: "#fff",
    boxShadow: "1px 0 0 #e5e7eb",
    backgroundClip: "padding-box",
  };
  const [shiftMode, setShiftMode] = useState("daily");
  const [halfMode, setHalfMode] = useState("first");
	const [salaryList, setSalaryList] = useState([]);
  const [salaryDetail, setSalaryDetail] = useState(null);
  const [attendanceMonth, setAttendanceMonth] = useState(getJstCurrentMonthInputValue);
  const [attendanceList, setAttendanceList] = useState([]);
  const [attendanceForm, setAttendanceForm] = useState(createEmptyAttendanceForm);
  const [editAttendanceId, setEditAttendanceId] = useState(null);
  const [newShiftUser, setNewShiftUser] = useState("");
  const [newShiftStart, setNewShiftStart] = useState("00:00");
  const [newShiftEnd, setNewShiftEnd] = useState("00:00");
  const [newUser, setNewUser] =
  useState({
    employeeId: "",
    password: "",
    name: "",
    hourlyWage: "",
    transportationFee: "",
    isAdmin: false,
  });
  const [passwords, setPasswords]= useState({});
  const adminTabs = [
    { id: "users", label: "従業員" },
    { id: "shifts", label: "シフト" },
    { id: "attendance", label: "勤怠" },
    { id: "salary", label: "給与" },
  ];

  const renderTabButton = (item) => (
    <button key={item.id} onClick={() => setTab(item.id)}
      className={`px-4 py-2 text-sm font-semibold rounded-lg transition ${
        tab === item.id? "bg-blue-600 text-white shadow-sm": "text-gray-600 hover:bg-gray-100"
      }`}>
      {item.label}
    </button>
  );

  const sectionTitle = (title, subTitle) => (
    <div style={{ margin: "22px 0 12px", }}>
      <h2 style={{ fontSize: "20px", fontWeight: 700, margin: 0, }}>{title}</h2>
      {subTitle && (
        <p style={{ color: "#6b7280", margin: "4px 0 0", fontSize: "13px", }}>
          {subTitle}
        </p>
      )}
    </div>
  );

  // =========================
  // ログアウト
  // =========================
  const handleLogout = () => {localStorage.clear();setUser(null);setPage("shop-login");};

  // =========================
  // フィルター
  // =========================
  const approvedShifts = shifts.filter((s) => s.status === "approved");

  const pendingShifts = shifts.filter( (s) => s.status !== "approved");
  const fetchSalarySummary = useCallback(async () => {
  const res = await fetch(
    apiUrl(`/salary-summary?month=${salaryMonth}`),
        {headers: {Authorization: `Bearer ${token}`,},});
    const data = await res.json();
    setSalaryList(data);
    }, [token, salaryMonth]);

  const fetchSalaryDetail = async (userId) => {
  const res = await fetch(
    apiUrl(`/salary-detail/${userId}?month=${salaryMonth}`),
      {headers: {Authorization: `Bearer ${token}`,},}
    );
    const data = await res.json();
    setSalaryDetail(data);
  };

  const fetchAttendance = useCallback(async () => {
    const res = await fetch(
      apiUrl(`/admin/attendance?month=${attendanceMonth}`),
      {
        headers: {Authorization: `Bearer ${token}`,},
      }
    );
    const data = await res.json();
    setAttendanceList(data);
  }, [token, attendanceMonth]);

  const resetAttendanceForm = () => {
    setAttendanceForm(createEmptyAttendanceForm());
    setEditAttendanceId(null);
  };

  const handleEditAttendance = (attendance) => {
    setEditAttendanceId(attendance.id);
    setAttendanceForm({
      userId: String(attendance.user_id),
      date: attendance.date,
      clockIn: attendance.clock_in_time || "09:00",
      clockOut: attendance.clock_out_time || "18:00",
      breakStart: attendance.break_start_time || "",
      breakEnd: attendance.break_end_time || "",
    });
  };

  const handleSaveAttendance = async () => {
    const path = editAttendanceId
      ? `/admin/attendance/${editAttendanceId}`
      : "/admin/attendance";
    const method = editAttendanceId ? "PUT" : "POST";

    const res = await fetch(
      apiUrl(path),
      {
        method,
        headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`,},
        body: JSON.stringify(attendanceForm),
      }
    );
    const data = await res.json();
    alert(data.message);

    if (res.ok) {
      resetAttendanceForm();
      fetchAttendance();
      fetchSalarySummary();
      setSalaryDetail(null);
    }
  };

  const handleDeleteAttendance = async (id) => {
    const ok = window.confirm("この勤怠実績を削除しますか？");
    if (!ok) return;

    const res = await fetch(
      apiUrl(`/admin/attendance/${id}`),
      {
        method: "DELETE",
        headers: {Authorization: `Bearer ${token}`,},
      }
    );
    const data = await res.json();
    alert(data.message);

    if (res.ok) {
      fetchAttendance();
      fetchSalarySummary();
      setSalaryDetail(null);
      if (editAttendanceId === id) {
        resetAttendanceForm();
      }
    }
  };
  // =========================
  // ユーザー更新
  // =========================
  const handleUpdateUser = async (user) => {
  const res = await fetch(
    apiUrl(`/users/${user.id}`),
      {
        method: "PUT",
        headers: {"Content-Type":"application/json",Authorization:`Bearer ${token}`,},
        body: JSON.stringify({
          hourlyWage:user.hourly_wage,
          transportationFee:user.transportation_fee,
          isAdmin:user.is_admin,
        }),
      }
    );
    const data =await res.json();
    alert(data.message);
    setEditId(null);
    fetchUsers();
  };
  // =========================
  // パスワード変更
  // =========================
  const changePassword = async (userId, password) => {
    if (!password) {return;}
    try {
      const token =localStorage.getItem("token");
      await fetch(
        apiUrl(`/users/${userId}/password`),
        {
          method: "PUT",
          headers: {"Content-Type":"application/json",Authorization:`Bearer ${token}`,},
          body: JSON.stringify({
            password,
          }),
        }
      );
      alert("変更成功");
    } catch (error) {
      console.error(error);
    }
  };
  // =========================
  // ユーザー追加
  // =========================
  const handleCreateUser = async () => {
    const res = await fetch(
      apiUrl("/admin/users"),
      {
        method: "POST",
        headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`,},
        body: JSON.stringify(
          newUser
        ),
      }
    );
    const data =await res.json();
    alert(data.message);
    if (res.ok) {
      setNewUser({
        employeeId: "",
        password: "",
        name: "",
        hourlyWage: "",
        transportationFee: "",
        isAdmin: false,
      });
      fetchUsers();
    }
  };

  const updateUserField = (userId, field, value) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === userId ? { ...user, [field]: value } : user
      )
    );
  };

  const handlePasswordInputChange = (userId, value) => {
    setPasswords((prev) => ({ ...prev, [userId]: value }));
  };

  const renderUserRow = (user) => {
    const isEditing = editId === user.id;
    const passwordValue = passwords[user.id] || "";

    return (
      <tr key={user.id}>
        <td style={tdStyle}>{user.employee_id}</td>
        <td style={{ ...tdStyle, textAlign: "left", fontWeight: 800 }}>{user.name}</td>
        <td style={tdStyle}>
          <span
            style={{
              padding: "4px 8px",
              borderRadius: "999px",
              background: user.is_admin ? "#dbeafe" : "#f3f4f6",
              color: user.is_admin ? "#1d4ed8" : "#4b5563",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {user.is_admin ? "管理者" : "スタッフ"}
          </span>
        </td>
        <td style={moneyCellStyle}>
          {isEditing ? (
            <Input
              className="w-28 mb-0"
              type="number"
              value={user.hourly_wage}
              onChange={(e) => updateUserField(user.id, "hourly_wage", e.target.value)}
            />
          ) : (
            `¥${Number(user.hourly_wage).toLocaleString()}`
          )}
        </td>
        <td style={moneyCellStyle}>
          {isEditing ? (
            <Input
              className="w-28 mb-0"
              type="number"
              value={user.transportation_fee}
              onChange={(e) => updateUserField(user.id, "transportation_fee", e.target.value)}
            />
          ) : (
            `¥${Number(user.transportation_fee).toLocaleString()}`
          )}
        </td>
        <td style={tdStyle}>
          <div style={{ display: "flex", gap: "8px", justifyContent: "center", minWidth: "210px" }}>
            <Input
              className="w-36 mb-0"
              type="password"
              placeholder="新しいPW"
              value={passwordValue}
              onChange={(e) => handlePasswordInputChange(user.id, e.target.value)}
            />
            <Button color="light" size="sm" onClick={() => changePassword(user.id, passwordValue)}>
              変更
            </Button>
          </div>
        </td>
        <td style={tdStyle}>
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            {isEditing ? (
              <>
                <Button color="green" size="sm" onClick={() => handleUpdateUser(user)}>
                  保存
                </Button>
                <Button color="light" size="sm" onClick={() => setEditId(null)}>
                  取消
                </Button>
              </>
            ) : (
              <>
                <Button size="sm" onClick={() => setEditId(user.id)}>
                  編集
                </Button>
                <Button color="red" size="sm" onClick={() => deleteUser(user.id)}>
                  削除
                </Button>
              </>
            )}
          </div>
        </td>
      </tr>
    );
  };

  // =========================
  // ユーザー削除
  // =========================
  const deleteUser = async (id) => {
    const ok = window.confirm("削除しますか？");
    if (!ok) return;
    try {
      const token = localStorage.getItem("token");
      await fetch(
        apiUrl(`/users/${id}`),
        {
          method: "DELETE",
          headers: {Authorization: `Bearer ${token}`,},
        }
      );
      fetchUsers();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteShift = async (id) => {
  const ok = window.confirm("このシフトを削除しますか？");
  if (!ok) return;
  const res = await fetch(
    apiUrl(`/shifts/${id}`),
    {
      method: "DELETE",
      headers: {Authorization: `Bearer ${token}`,  },
    }
  );
  const data = await res.json();
  alert(data.message);
  fetchShifts();
  fetchSalarySummary();
};

  // =========================
  // ユーザー取得
  // =========================
  const fetchUsers = useCallback(async () => {
  const res = await fetch(
    apiUrl("/users"),
      {
        headers: {Authorization:`Bearer ${token}`,},
      }
    );
    const data =await res.json();
    setUsers(data);
  }, [token]);

  // =========================
  // シフト取得
  // =========================
  const fetchShifts = useCallback(async () => {
    const res = await fetch(
      apiUrl("/shifts"),
      {
        headers: {Authorization:`Bearer ${token}`, },
      }
    );
    const data =await res.json();
    setShifts(data);
  }, [token]);

  // =========================
  // シフト更新
  // =========================
  const handleShiftUpdate = async (shift) => {
    const res = await fetch(
      apiUrl(`/shifts/${shift.id}`),
      {
        method: "PUT",
        headers: {"Content-Type":"application/json",Authorization:`Bearer ${token}`,},
        body: JSON.stringify({
          date: shift.date,
          startTime:shift.start_time,
          endTime:shift.end_time,
        }),
      }
    );
      const data = await res.json();
  alert(data.message);

    setEditShiftId(null);
    fetchShifts();
    fetchSalarySummary();
  };

  // =========================
  // ステータス変更
  // =========================
  const handleStatusChange = async (id,status) => {
    const res = await fetch(
      apiUrl(`/shifts/${id}/status`),
      {
        method: "PUT",
        headers: {"Content-Type":"application/json",Authorization:`Bearer ${token}`,},
        body: JSON.stringify({status,}),
      }
    );
    const data =await res.json();
    alert(data.message);
    fetchShifts();
    fetchSalarySummary();
  };

  // =========================
  // シフト作成
  // =========================
  const handleCreateShift = async () => {

  if (!newShiftUser) {
    alert("従業員を選択してください");
    return;
  }

  const formattedDate =
    `${selectedDate.getFullYear()}-${
      String(selectedDate.getMonth() + 1).padStart(2, "0")
    }-${
      String(selectedDate.getDate()).padStart(2, "0")
    }`;

	  const res = await fetch(
	    apiUrl("/shifts"),
    {
      method: "POST",
      headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`,},
      body: JSON.stringify({
        userId: newShiftUser,
        date: formattedDate,
        startTime: newShiftStart,
        endTime: newShiftEnd,
      }),
    }
  );
  const data = await res.json();
  alert(data.message);
  fetchShifts();
};

  // =========================
  // 給与
  // =========================
  const filteredSalaryList =
  salaryList.filter((item) => item.month === salaryMonth);

  // =========================
  // 日毎の人件費
  // =========================

  const dailySalary = approvedShifts
  .filter( (s) => isSameLocalDate(s.date, selectedDate))
  .reduce((total, shift) => {
    const user = users.find((u) =>  Number(u.id) === Number(shift.user_id));
    if (!user) return total;
    return total + calculateShiftSalary({
      startTime: shift.start_time,
      endTime: shift.end_time,
      hourlyWage: user.hourly_wage,
      transportationFee: user.transportation_fee,
    });
  }, 0);
  // =========================
  // 初期ロード
  // =========================
  useEffect(() => {
    const checkAdmin = async () => {
	        const res = await fetch(
	        apiUrl("/admin"),
        {
          headers: {Authorization:`Bearer ${token}`,},
        }
      );
      if (!res.ok) {
        alert("管理者のみ");
        localStorage.clear();
        setUser(null);
        return;
      }
    };
    checkAdmin();
    fetchUsers();
    fetchShifts();
    fetchSalarySummary();
  }, [
    setUser,
    token,
    fetchUsers,
    fetchShifts,
    fetchSalarySummary,
  ]);
  useEffect(() => {fetchSalarySummary();}, [fetchSalarySummary]);
  useEffect(() => {fetchAttendance();}, [fetchAttendance]);
  useEffect(() => {
    setSalaryDetail(null);
  }, [salaryMonth]);

  // =========================
  // シフトカード
  // =========================
	  const renderShiftCard = (shift) => (

	    <Card key={shift.id} className="p-4">
	      <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "center", flexWrap: "wrap", }}>
	      <div>
	      <p style={{ margin: 0, color: "#6b7280", fontSize: "12px", }}>名前</p>
	      <h3 style={{ margin: "2px 0 6px", fontSize: "17px", fontWeight: 700, }}>{shift.name}</h3>
	      </div>
	      <span style={{ padding: "4px 8px", borderRadius: "999px", background: shift.status === "approved" ? "#dcfce7" : "#fef3c7", color: shift.status === "approved" ? "#166534" : "#92400e", fontSize: "12px", fontWeight: 700, }}>
	        {shift.status === "approved" ? "確定" : "未確定"}
	      </span>
	      </div>
	      {editShiftId === shift.id ? (
	        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "10px" }}>
	          <select value={shift.start_time?.slice(0,5)} onChange={(e)=>{
              const updated=shifts.map((s)=>
                s.id===shift.id ? {...s,start_time:e.target.value}: s
              );
              setShifts(updated);
            }}
          >
            {timeOptions.map((time)=>(
              <option key={time} value={time}> {time}</option>
            ))}
          </select>
          <select value={shift.end_time?.slice(0,5)}onChange={(e)=>{
              const updated=shifts.map((s)=>
                s.id===shift.id ? {...s,end_time:e.target.value}: s
              );
              setShifts(updated);
            }}>
            {timeOptions.map((time)=>(
              <option key={time} value={time}>{time}</option>
            ))}
          </select>

	          <Button color="green" size="auto" onClick={() =>handleShiftUpdate(shift)}>保存</Button>
	        </div>
	      ) : (
	        <p style={{ fontSize: "22px", fontWeight: 800, margin: "6px 0 12px", }}>{shift.start_time?.slice(0,5)}〜{shift.end_time?.slice(0,5)}</p>
	      )}
	      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "10px" }}>
	        {editShiftId !== shift.id && (
	          <Button size="sm" onClick={() =>setEditShiftId(shift.id)}>編集</Button>
	        )}
	        <Button color={shift.status ==="approved" ? "light" : "green"} size="sm" onClick={() => handleStatusChange(shift.id,shift.status ==="approved"? "pending": "approved")}>
	          {shift.status ==="approved"? "未確定へ": "確定"}
	        </Button>
	        <Button color="red"size="sm"onClick={() => handleDeleteShift(shift.id)}>削除</Button>
	      </div>
	    </Card>
	  );

  // =========================
  // 日程処理
  // =========================
  const selectedYear = selectedDate.getFullYear();
  const selectedMonth = selectedDate.getMonth();

  const daysInMonth = getDaysInMonthFromInputValue(
    `${selectedYear}-${String(selectedMonth + 1).padStart(2, "0")}`
  );
  const displayDays = halfMode === "first"
    ? [...Array(15)].map((_, i) => i + 1): [...Array(daysInMonth - 15)].map((_, i) => i + 16);

  // =========================
  // 月毎シフト
  // =========================

  const monthlyShifts = approvedShifts.filter((s) => {
    const shiftDate = createLocalDateFromInputValue(s.date);
    return (shiftDate.getFullYear() === selectedYear && shiftDate.getMonth() === selectedMonth);
  }).sort((a, b) => createLocalDateFromInputValue(a.date) - createLocalDateFromInputValue(b.date));

	  const totalSalary =filteredSalaryList.reduce( (sum, item) => sum + Number(item.totalSalary),0);
	  return (
	    <div>
	      <Navbar />
	      <main className="page-shell" style={{ maxWidth: "1180px", }}>
	      <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "center", marginBottom: "18px", flexWrap: "wrap", }}>
	        <div>
	          <Title>管理者画面</Title>
	          <p style={{ margin: 0, color: "#6b7280", fontSize: "14px", }}>従業員、シフト、給与をまとめて管理します。</p>
	        </div>
	        <Button color="red" size="auto" onClick={handleLogout}>ログアウト</Button>
	      </div>
	      <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", }}>
	        <div className="toolbar-scroll" style={{ padding: "4px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", }}>
	          {adminTabs.map(renderTabButton)}
	        </div>
	        <Button color="light" size="auto" onClick={() => setPage("attendance")}>出退勤画面</Button>
	      </div>
      {/* ================= USERS ================= */}
	      {tab === "users" && (
	        <>
	        <Card className="p-5">
	          {sectionTitle("従業員追加", "基本情報と給与条件を登録します。")}
	          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(180px, 100%), 1fr))", gap: "12px", alignItems: "end", }}>
	            <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	              従業員ID
	              <Input className="mt-1 w-full" placeholder="例: 1001" value={newUser.employeeId} onChange={(e) => setNewUser({ ...newUser, employeeId: e.target.value, }) }/>
	            </label>
	            <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	              パスワード
	              <Input className="mt-1 w-full" placeholder="初期PW" type="password" value={newUser.password} onChange={(e) =>
	                setNewUser({ ...newUser,password:e.target.value,})}/>
	            </label>
	            <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	              名前
	              <Input className="mt-1 w-full" placeholder="山田 太郎" value={newUser.name} onChange={(e) =>
	                  setNewUser({ ...newUser, name: e.target.value,})}/>
	            </label>
	            <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	              時給
	              <Input className="mt-1 w-full" placeholder="1200" type="number" value={newUser.hourlyWage} onChange={(e) =>
	                  setNewUser({ ...newUser,hourlyWage:e.target.value,})}/>
	            </label>
	            <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	              交通費
	              <Input className="mt-1 w-full" placeholder="500" type="number" value={newUser.transportationFee}onChange={(e) =>
	                setNewUser({...newUser, transportationFee:e.target.value,})}/>
	            </label>
	            <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", fontWeight: 700, color: "#374151", marginBottom: "12px", }}>
	              <input type="checkbox" checked={newUser.isAdmin} onChange={(e) => setNewUser({ ...newUser, isAdmin: e.target.checked,})}/>
	              管理者
	            </label>
	            <Button color="green" size="auto" onClick={handleCreateUser}>追加</Button>
	          </div>
	        </Card>
	        <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "end", flexWrap: "wrap", marginTop: "18px" }}>
	          {sectionTitle("従業員一覧", `${users.length}名登録中`)}
	          <Input className="w-full max-w-sm mb-0" placeholder="名前で検索" value={search} onChange={(e)=>setSearch(e.target.value)}/>
	        </div>
	        <div className="table-scroll" style={{ overflowX: "auto" }}>
	          <table style={tableStyle}>
	            <thead>
	              <tr>
	                <th style={thStyle}>従業員ID</th>
	                <th style={thStyle}>名前</th>
	                <th style={thStyle}>権限</th>
	                <th style={thStyle}>時給</th>
	                <th style={thStyle}>交通費</th>
	                <th style={thStyle}>パスワード</th>
	                <th style={thStyle}>操作</th>
	              </tr>
	            </thead>
	            <tbody>
{users.filter((user)=>user.name.toLowerCase().includes(search.toLowerCase())).map(renderUserRow)}
	            </tbody>
	          </table>
	        </div>
        </>
      )}

{/* ================= SHIFTS ================= */}
	{tab === "shifts" && (
	  <>
	    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap", marginBottom: "16px", }}>
	      {sectionTitle("シフト管理", "確定、編集、追加を日別または月間で確認できます。")}
	      <div className="toolbar-scroll" style={{ padding: "4px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", }}>
	        <button onClick={() =>setShiftMode("daily")} className={`px-4 py-2 text-sm font-semibold rounded-lg ${shiftMode === "daily" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>日別</button>
	        <button onClick={() =>setShiftMode("monthly")} className={`px-4 py-2 text-sm font-semibold rounded-lg ${shiftMode === "monthly" ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"}`}>月間</button>
	      </div>
	    </div>

	{/* ================= daily shifts ================= */}
	    {shiftMode === "daily" && (
	      <>
	          <div className="mb-4">
	          </div>
	          <div style={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(280px, 100%), 1fr))", gap: "20px", alignItems: "start",}}>
	          <div>
	              <Card className="p-5">
	                <Calendar onChange={ setSelectedDate} value={selectedDate}/>
	                <p style={{ margin: "12px 0 0", fontWeight: 700, }}>選択日:{" "}{formatInputDateToJapanese(`${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`)}</p>
	              </Card>
	            </div>
	            <div>
	              <Card className="p-5">
	                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap", }}>
	                  <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, }}>シフト追加</h3>
	                  <div style={{ background: "#ecfdf5", color: "#047857", borderRadius: "8px", padding: "8px 12px", fontWeight: 700, }}>
	                    当日の人件費 ¥{Math.floor(dailySalary).toLocaleString()}
	                  </div>
	                </div>
	                <div style={{ marginTop: "14px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(140px, 100%), 1fr))", gap: "10px", alignItems: "center" }}>
	                <select value={newShiftUser} onChange={(e) => setNewShiftUser(e.target.value)}>
	                  <option value=""> 従業員選択 </option>
	                  {users.map((user) => (
                    <option key={user.id} value={user.id}> {user.name}</option>
                  ))}
                </select>

                <select value={newShiftStart} onChange={(e) => setNewShiftStart(e.target.value)}>
                  {timeOptions.map((time) => (
                    <option key={time} value={time}>{time}</option>
                  ))}
                </select>

                <select value={newShiftEnd} onChange={(e) => setNewShiftEnd(e.target.value)}>
                  {timeOptions.map((time) => (
	                    <option key={time} value={time}>{time}</option>
	                  ))}
	                </select>
	                <Button color="green" size="full" onClick={handleCreateShift}>追加</Button>
	                </div>
	              </Card>
	              {sectionTitle("確定シフト")}
	              <Grid columns={1}gap="10px">
	                {approvedShifts.filter((s) => isSameLocalDate(s.date, selectedDate)).length === 0 ? (
	                  <Card><p style={{ margin: 0, color: "#64748b" }}>この日の確定シフトはありません</p></Card>
	                ) : approvedShifts.filter((s) => isSameLocalDate(s.date, selectedDate))
	                  .map(renderShiftCard)}
	              </Grid>
	            </div>
	          </div>
	          {sectionTitle("未確定シフト")}
	          <Grid columns={1} gap="10px">
	            {pendingShifts.filter((s) => isSameLocalDate(s.date, selectedDate)).length === 0 ? (
	              <Card><p style={{ margin: 0, color: "#64748b" }}>この日の未確定シフトはありません</p></Card>
	            ) : pendingShifts.filter((s) => isSameLocalDate(s.date, selectedDate))
	              .map(renderShiftCard)}
          </Grid>
        </>
      )}

  {/* ================= monthly shifts ================= */}
	      {shiftMode === "monthly" && (
	    <>
	      {sectionTitle("月間シフト表")}
	      <div className="toolbar-scroll" style={{marginBottom: "20px",alignItems: "center"}}>
	        <Input className="mb-0" type="month"value={`${selectedYear}-${String(selectedMonth + 1).padStart(2, "0")}`}
	          onChange={(e) => {
	            const [year, month] = e.target.value.split("-");
	            setSelectedDate(new Date(Number(year), Number(month) - 1, 1));
	          }}
	        />
	        <Button color={halfMode === "first" ? "blue" : "light"} size="auto" onClick={() => setHalfMode("first")}>前半</Button>
	        <Button color={halfMode === "second" ? "blue" : "light"} size="auto" onClick={() => setHalfMode("second")}>後半</Button>
	      </div>

	      <div className="table-scroll" style={shiftTableWrapStyle}>
	      <table style={shiftTableStyle}>
        <thead>
          <tr>
            <th style={stickyNameHeaderStyle}>従業員</th>
            {displayDays.map((day) => (<th key={day} style={{...stickyDayHeaderStyle,minWidth: "80px",}}>{day}</th>))}
          </tr>
        </thead>

        <tbody>
          {users.map((user) => ( <tr key={user.id}><td style={stickyNameCellStyle}>{user.name}</td>
              {displayDays.map((day) => {
                const shift = monthlyShifts.find((s) => {
                  const shiftDate = createLocalDateFromInputValue(s.date);
                  return (Number(s.user_id) === Number(user.id) &&shiftDate.getDate() === day);
                });
                return (
                  <td key={day} style={{...tdStyle,fontSize: "13px",minWidth: "80px",}}>
                    {shift ? `${shift.start_time?.slice(0,5)}〜${shift.end_time?.slice(0,5)}`: "-" }
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </>
  )}
    </>
    )}

	     {/* ================= ATTENDANCE ================= */}
	      {tab === "attendance" && (
	        <>
	          <Card className="p-5">
	            <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "center", flexWrap: "wrap", }}>
	              <div>
	                <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700, }}>
	                  勤怠実績
	                </h2>
	                <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: "13px", }}>
	                  打刻漏れや修正が必要な勤務実績を管理します。
	                </p>
	              </div>
	              <Input
	                className="mb-0"
	                type="month"
	                value={attendanceMonth}
	                onChange={(e) => setAttendanceMonth(e.target.value)}
	              />
	            </div>
	          </Card>

	          <Card className="p-5 mt-4">
	            {sectionTitle(editAttendanceId ? "勤怠実績編集" : "勤怠実績追加", "休憩は開始と終了の両方を入力した場合のみ反映されます。")}
	            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(150px, 100%), 1fr))", gap: "10px", alignItems: "end" }}>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                従業員
	                <select
	                  className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2.5 bg-white text-sm"
	                  value={attendanceForm.userId}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, userId: e.target.value })}
	                >
	                  <option value="">選択</option>
	                  {users.map((user) => (
	                    <option key={user.id} value={user.id}>{user.name}</option>
	                  ))}
	                </select>
	              </label>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                日付
	                <Input
	                  className="mt-1 mb-0 w-full"
	                  type="date"
	                  value={attendanceForm.date}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, date: e.target.value })}
	                />
	              </label>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                出勤
	                <Input
	                  className="mt-1 mb-0 w-full"
	                  type="time"
	                  step="60"
	                  value={attendanceForm.clockIn}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, clockIn: e.target.value })}
	                />
	              </label>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                退勤
	                <Input
	                  className="mt-1 mb-0 w-full"
	                  type="time"
	                  step="60"
	                  value={attendanceForm.clockOut}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, clockOut: e.target.value })}
	                />
	              </label>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                休憩開始
	                <Input
	                  className="mt-1 mb-0 w-full"
	                  type="time"
	                  step="60"
	                  value={attendanceForm.breakStart}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, breakStart: e.target.value })}
	                />
	              </label>
	              <label style={{ fontSize: "13px", fontWeight: 700, color: "#374151", }}>
	                休憩終了
	                <Input
	                  className="mt-1 mb-0 w-full"
	                  type="time"
	                  step="60"
	                  value={attendanceForm.breakEnd}
	                  onChange={(e) => setAttendanceForm({ ...attendanceForm, breakEnd: e.target.value })}
	                />
	              </label>
	              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
	                <Button color="green" size="auto" onClick={handleSaveAttendance}>
	                  {editAttendanceId ? "保存" : "追加"}
	                </Button>
	                {editAttendanceId && (
	                  <Button color="light" size="auto" onClick={resetAttendanceForm}>取消</Button>
	                )}
	              </div>
	            </div>
	          </Card>

	          {sectionTitle("勤怠実績一覧", `${attendanceList.length}件`)}
	          <div className="table-scroll" style={{ overflowX: "auto", }}>
	            <table style={tableStyle}>
	              <thead>
	                <tr>
	                  <th style={thStyle}>日付</th>
	                  <th style={thStyle}>従業員ID</th>
	                  <th style={thStyle}>名前</th>
	                  <th style={thStyle}>出勤</th>
	                  <th style={thStyle}>退勤</th>
	                  <th style={thStyle}>休憩</th>
	                  <th style={thStyle}>操作</th>
	                </tr>
	              </thead>
	              <tbody>
	                {attendanceList.length === 0 ? (
	                  <tr>
	                    <td style={{ ...tdStyle, color: "#64748b" }} colSpan="7">
	                      この月の勤怠実績はありません
	                    </td>
	                  </tr>
	                ) : attendanceList.map((attendance) => (
	                  <tr key={attendance.id}>
	                    <td style={tdStyle}>{attendance.date}</td>
	                    <td style={tdStyle}>{attendance.employee_id}</td>
	                    <td style={{ ...tdStyle, textAlign: "left", fontWeight: 800 }}>{attendance.name}</td>
	                    <td style={tdStyle}>{attendance.clock_in_time}</td>
	                    <td style={tdStyle}>{attendance.clock_out_time}</td>
	                    <td style={tdStyle}>
	                      {attendance.break_start_time && attendance.break_end_time
	                        ? `${attendance.break_start_time}〜${attendance.break_end_time}`
	                        : "-"}
	                    </td>
	                    <td style={tdStyle}>
	                      <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
	                        <Button size="sm" onClick={() => handleEditAttendance(attendance)}>編集</Button>
	                        <Button color="red" size="sm" onClick={() => handleDeleteAttendance(attendance.id)}>削除</Button>
	                      </div>
	                    </td>
	                  </tr>
	                ))}
	              </tbody>
	            </table>
	          </div>
	        </>
	      )}

	     {/* ================= SALARY ================= */}
	      {tab === "salary" && (
	        <>
	        <Card className="p-5">
	        <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "center", flexWrap: "wrap", }}>
	          <div>
	            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700, }}>月別給与一覧</h2>
	            <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: "13px", }}>勤怠実績にもとづく確定給与です。</p>
	          </div>
	          <div style={{ background: "#eff6ff", color: "#1d4ed8", borderRadius: "8px", padding: "12px 16px", fontWeight: 800, fontSize: "18px", }}>
	            月合計 ¥{totalSalary.toLocaleString()}
	          </div>
	        </div>
	          <Input className="mt-4 mb-0" type="month" value={salaryMonth}
	            onChange={(e) => setSalaryMonth(e.target.value)}/>
	        </Card>
	            <div className="table-scroll" style={{ overflowX: "auto", }}>
	            <table style={tableStyle}>
	              <thead>
	                <tr>
	                  <th style={thStyle}>名前</th>
                  <th style={thStyle}>実働時間</th>
                  <th style={thStyle}>通常</th>
                  <th style={thStyle}>深夜</th>
                  <th style={thStyle}>残業</th>
                  <th style={thStyle}>深夜残業</th>
                  <th style={thStyle}>交通費</th>
                  <th style={thStyle}>給与</th>
                  <th style={thStyle}>明細</th>
                </tr>
              </thead>
              <tbody>
	                {filteredSalaryList.map((item, index) => (
	                  <tr key={index}>
	                    <td style={tdStyle}>{item.name}</td>
	                    <td style={tdStyle}>{formatHoursMinutes(item.totalHours)}</td>
	                    <td style={moneyCellStyle}>¥{Number(item.regularSalary || 0).toLocaleString()}</td>
	                    <td style={moneyCellStyle}>¥{Number(item.nightSalary || 0).toLocaleString()}</td>
	                    <td style={moneyCellStyle}>¥{Number(item.overtimeSalary || 0).toLocaleString()}</td>
	                    <td style={moneyCellStyle}>¥{Number(item.nightOvertimeSalary || 0).toLocaleString()}</td>
	                    <td style={moneyCellStyle}>¥{Number(item.transportation || 0).toLocaleString()}</td>
	                    <td style={{...moneyCellStyle, fontWeight: 800, color: "#111827",}}>¥{item.totalSalary.toLocaleString()}</td>
	                    <td style={tdStyle}>
	                      <Button size="auto" onClick={() => fetchSalaryDetail(item.userId)}>表示</Button>
	                    </td>
	                  </tr>
	                ))}
	              </tbody>
	            </table>
	            </div>
	            {salaryDetail && (
	              <>
	                {sectionTitle(`給与明細：${salaryDetail.summary.name}`, `明細合計 ¥${Number(salaryDetail.summary.totalSalary).toLocaleString()} / 交通費 ¥${Number(salaryDetail.summary.transportation).toLocaleString()}`)}
	                <div className="table-scroll" style={{ overflowX: "auto", }}>
	                <table style={{ ...tableStyle, fontSize: "12px",}}>
	                  <thead>
	                    <tr>
	                      <th style={thStyle}>日付</th>
                      <th style={thStyle}>実働</th>
                      <th style={thStyle}>通常</th>
                      <th style={thStyle}>深夜</th>
                      <th style={thStyle}>残業</th>
                      <th style={thStyle}>深夜残業</th>
                      <th style={thStyle}>交通費</th>
                      <th style={thStyle}>日給</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salaryDetail.details.map((detail, index) => (
	                      <tr key={index}>
	                        <td style={tdStyle}>{detail.date}</td>
	                        <td style={tdStyle}>{formatHoursMinutes(detail.actualHours)}</td>
	                        <td style={moneyCellStyle}>
	                          {detail.regularHours}h / ¥{Number(detail.regularSalary).toLocaleString()}
	                        </td>
	                        <td style={moneyCellStyle}>
	                          {detail.nightHours}h / ¥{Number(detail.nightSalary).toLocaleString()}
	                        </td>
	                        <td style={moneyCellStyle}>
	                          {detail.overtimeHours}h / ¥{Number(detail.overtimeSalary).toLocaleString()}
	                        </td>
	                        <td style={moneyCellStyle}>
	                          {detail.nightOvertimeHours}h / ¥{Number(detail.nightOvertimeSalary).toLocaleString()}
	                        </td>
	                        <td style={moneyCellStyle}>¥{Number(detail.transportation).toLocaleString()}</td>
	                        <td style={{...moneyCellStyle, fontWeight: 800,}}>¥{Number(detail.totalSalary).toLocaleString()}</td>
	                      </tr>
	                    ))}
	                  </tbody>
	                </table>
	                </div>
	              </>
	            )}
        </>
      )}
	      </main>
	  </div>
	  );
}
export default Admin;
